import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {

  static targets = ["sortable", "route"]
  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      onEnd: this.updateOrder.bind(this)
    })
  }

  updateOrder(event) {
    const items = Array.from(this.element.children).map((el, index) => {
      return {
        id: el.dataset.id,
        position: index + 1
      }
    })
    fetch(this.routeTarget.dataset.route, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ items: items })
    }).then(response => {
      if (response.ok) {
        console.log("Success:", response.statusText);
      } else {
        console.error("Error:", response.statusText);
      }
    })
  }
}